import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

import { __ } from '../../utilities';
import Icon from '../Icon/index';

const Seat = styled(Icon)`
  position: relative;
  width: ${rem(33)};
  height: ${rem(33)};
  &:before {
    position: absolute;
    top: 50%;
    left: 45%;
    font-size ${rem(14)};
    transform: translate(-45%, -50%);
  }
  ${props => {
    let number = '';
    let colorOfNumber = '';
    if (props.number) {
      number = props.number;
    }
    if (props.colorOfNumber) {
      colorOfNumber = props.colorOfNumber;
    }
    return `
      &:before {
        content: '${number}';
        color: ${colorOfNumber};
      }
    `;
  }};
`;

const SeatBoxClickable = styled.span`
  margin-left: ${rem(10)};
  cursor: pointer;
`;

const SeatBoxNonClickable = styled.span`
  margin-left: ${rem(10)};
  cursor: not-allowed;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.color.font.primary};
  font-size: ${rem(14)};
`;

const HintTitle = styled.div`
  width: auto;
  display: flex;
  overflow: auto;
  flex-direction: row;
  margin-left: ${rem(10)};
  justify-content: center;
  align-items: center;
  position: relative;
  @media (max-width: ${rem(1000)}) {
    margin-right: ${rem(20)};
  }
`;

const NonSeat = styled.div`
  width: ${rem(33)};
  height: ${rem(33)};
  margin-left: ${rem(10)};
  border-radius: ${rem(3)};
`;

const Row = styled.div`
  padding-bottom: ${rem(5)};
  display: flex;
  flex-direction: row;
`;

const Table = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin-top: ${rem(30)};
  flex-direction: column;
  align-items: center;
  @media (max-width: ${rem(1000)}) {
    align-items: left;
  }
`;

const Hint = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${rem(1000)}) {
    flex-direction: row;
    margin-top: ${rem(50)};
  }
  @media (max-width: ${rem(380)}) {
    flex-direction: column;
    margin-top: ${rem(50)};
  }
`;

const Scroller = styled.div`
  width: 100%;
  overflow: auto;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: ${rem(1000)}) {
    flex-direction: column;
  }
`;

class BusLayout extends Component {
  render() {
    const table = [];
    this.props.layout.forEach((row, indexOfRow) => {
      const grid = [];
      row.seats.forEach((seat, indexOfSeat) => {
        if (seat.isSeat) {
          if (this.props.selectedSeats.includes(seat.seatId)) {
            grid.push(
              <SeatBoxClickable
                key={indexOfSeat}
                onClick={() =>
                  this.props.selectSeat(
                    seat.seatId,
                    this.props.possibleSeatSelect,
                  )
                }
              >
                <Seat
                  name="selectedSeat"
                  number={seat.seatId}
                  colorOfNumber="#FFF"
                />
              </SeatBoxClickable>,
            );
          } else if (seat.available) {
            grid.push(
              <SeatBoxClickable
                key={indexOfSeat}
                onClick={() => this.props.selectSeat(seat.seatId)}
              >
                <Seat
                  name="seat"
                  color="#FFF"
                  number={seat.seatId}
                  colorOfNumber="#333333"
                />
              </SeatBoxClickable>,
            );
          } else {
            grid.push(
              <SeatBoxNonClickable key={indexOfSeat}>
                <Seat
                  name="seat"
                  color="#DDD"
                  number={seat.seatId}
                  colorOfNumber="#aaaaaa"
                />
              </SeatBoxNonClickable>,
            );
          }
        } else {
          grid.push(<NonSeat key={indexOfSeat} />);
        }
      });
      table.push(<Row key={indexOfRow}>{grid}</Row>);
    });

    return (
      <Wrapper>
        <Scroller>
          <Table>{table}</Table>
        </Scroller>
        <Hint>
          <Row>
            {' '}
            <Seat name="seat" color="#FFF" />{' '}
            <HintTitle>
              <Title>{__('Voľné')}</Title>
            </HintTitle>
          </Row>
          <Row>
            {' '}
            <Seat name="seat" color="#DDD" />{' '}
            <HintTitle>
              {' '}
              <Title>{__('Obsadené')}</Title>
            </HintTitle>
          </Row>
          <Row>
            <Seat name="selectedSeat" />{' '}
            <HintTitle>
              <Title>{__('Vybrané')}</Title>
            </HintTitle>
          </Row>
        </Hint>
      </Wrapper>
    );
  }
}

BusLayout.propTypes = {
  layout: PropTypes.arrayOf(PropTypes.shape({})),
  selectSeat: PropTypes.func,
  selectedSeats: PropTypes.arrayOf(PropTypes.number),
  possibleSeatSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
};

BusLayout.defaultProps = {
  layout: [],
  selectSeat: () => {},
  selectedSeats: [],
  possibleSeatSelect: [],
};

export default BusLayout;



// WEBPACK FOOTER //
// ./src/components/Bus/busLayout.js